import ViewContentCreatorInvitations from 'features/view/content/creator/invitations/view-content-creator-invitations'
import ViewContentCreatorInviteCard from 'features/view/content/creator/invite/card/view-content-creator-invite-card'
import ViewContentHouseAccessList from 'features/view/content/house/access/list/view-content-house-access-list'
import ViewInviteCard from 'features/view/invite/card/view-invite-card'
import ViewPlayerAccessList from 'features/view/player/access/list/view-player-access-list'
import ViewProfileCommands from 'features/view/profile/commands/view-profile-commands'
import ViewProfileList from 'features/view/profile/list/view-profile-list'
export function GetProfileSectionCards() {
  return [
    <ViewContentCreatorInvitations key="ViewContentCreatorInvitations-0" />,
    <ViewContentCreatorInviteCard key="ViewContentCreatorInviteCard-1" />,
    <ViewInviteCard key="ViewInviteCard-2" />,
    <ViewProfileList key="ViewProfileList-3" />,
    <ViewProfileCommands key="ViewProfileCommands-4" />,
    <ViewContentHouseAccessList key="ViewContentHouseAccessList-5" />,
    <ViewPlayerAccessList key="ViewPlayerAccessList-6" />,
  ]
}
export function GetNotificationComponents() {
  return []
}
